<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="md:col-12 lg:col-12 col-12">
      <app-detalle-tercero *ngIf="tercero && tercero.idTercero" [third]="tercero" [view]="false"
                           [edit]="false"
                           [clasification]="false"></app-detalle-tercero>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'SUCURSALES.LBL_SUCURSALES' | translate}}">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{sucursal?.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{sucursal?.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_ALIAS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{sucursal?.alias}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_USUARIOS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{sucursal?.cantidadUsuarios}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_CUPOVALOR' | translate }}:</label>
          <label
            class="lg:col-3 col-6 md:col-8"><strong>{{sucursal?.cupoValor | dinero : 2   }}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_CUPOCREDITO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{sucursal?.cupoCredito}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_UBICACION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{sucursal?.descripcionDivisionPolitica}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_ESTRUCTURAFISICA' | translate }}
            :</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{sucursal?.nombreEstructuraFisica}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SUCURSALES.LBL_PRINCIPAL' | translate }}:</label>
          <label
            class="lg:col-3 col-6 md:col-8 "><strong>{{sucursal?.indicadorPrincipal ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label
            class="lg:col-3 col-6 md:col-8 "><strong>{{sucursal?.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid" *ngIf="todo">
    <div class="col-12">
      <p-panel header="{{ 'SUCURSALES.LBL_USUARIOS' | translate}}">
        <app-aliados-usuarios [sucursal]="sucursal" [detalle]="true"></app-aliados-usuarios>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
